import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { QUERIES as T } from "@fcamna/shared-component-foundations";
import { createContext as k, useState as E, useContext as F, useRef as H, useEffect as L } from "react";
import a, { css as O } from "styled-components";
import { u as R } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { CloseButton as U } from "./closeButton.js";
import { Disclosures as j } from "./disclosure.js";
import { D as b } from "./index-2be68378.mjs";
import { h as A } from "./hTag-27bb1617.mjs";
import { Ellipses as P, Menu as q } from "./menu.js";
import { u as C } from "./useAccessibilityProps-2f24cf29.mjs";
import { u as K } from "./uniqueId-321287e8.mjs";
import { m as B, A as N } from "./index-5d51183d.mjs";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./iconButton.js";
import "./button.js";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./icon.js";
import "@fcamna/shared-icons";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./helperText-d9646f54.mjs";
import "./textInput.js";
import "./radio.js";
import "./tslib.es6-59e1c9d8.mjs";
const z = k({}), I = "Drawer", Q = () => `
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, _ = a(B.div)`
  ${({ theme: { componentStyles: e } }) => O(e)};
  display: ${(e) => e.theme.components.drawer.DrawerContainer.display};
  flex-direction: ${(e) => e.theme.components.drawer.DrawerContainer.flexDirection};
  position: ${(e) => e.theme.components.drawer.DrawerContainer.position};
  top: ${(e) => e.theme.components.drawer.DrawerContainer.top};
  height: ${(e) => e.theme.components.drawer.DrawerContainer.height};
  z-index: ${(e) => e.theme.components.drawer.DrawerContainer.zIndex};
  box-shadow: ${(e) => e.theme.components.drawer.DrawerContainer.boxShadow};
  background-color: ${(e) => e.theme.components.drawer.DrawerContainer.backgroundColor};
  width: ${(e) => e.theme.components.drawer.DrawerContainer.width};
  right: ${({ placement: e, ...r }) => e === "left" ? r.theme.components.drawer.DrawerContainer.right.left : r.theme.components.drawer.DrawerContainer.right.default};
  max-width: ${(e) => e.theme.components.drawer.DrawerContainer.maxWidth};
  @media ${T.tabletAndUp} {
    max-width: ${(e) => e.theme.components.drawer.DrawerContainer.tabletAndUp.maxWidth[e.size ?? "unset"]};
    width: ${(e) => e.theme.components.drawer.DrawerContainer.tabletAndUp.width[e.size ?? "default"]};
    right: ${(e) => e.theme.components.drawer.DrawerContainer.tabletAndUp.right[e.placement === "right" ? e.size ?? "default" : "unset"]};
    left: ${(e) => e.theme.components.drawer.DrawerContainer.tabletAndUp.right[e.placement === "left" ? 0 : "unset"]};
  }
`, G = a.div`
  position: ${(e) => e.theme.components.drawer.Overlay.position};
  top: ${(e) => e.theme.components.drawer.Overlay.top};
  left: ${(e) => e.theme.components.drawer.Overlay.left};
  width: ${(e) => e.theme.components.drawer.Overlay.width};
  height: ${(e) => e.theme.components.drawer.Overlay.height};
  background-color: ${(e) => e.theme.components.drawer.Overlay.backgroundColor};
  z-index: ${(e) => e.theme.components.drawer.Overlay.zIndex};
`, X = a.div`
  min-height: ${(e) => e.theme.components.drawer.DrawerHeaderWrapper.minHeight};
  display: ${(e) => e.theme.components.drawer.DrawerHeaderWrapper.display};
  box-sizing: ${(e) => e.theme.components.drawer.DrawerHeaderWrapper.boxSizing};
  justify-content: ${(e) => e.theme.components.drawer.DrawerHeaderWrapper.justifyContent};
  align-items: ${(e) => e.theme.components.drawer.DrawerHeaderWrapper.alignItems};
  padding: ${(e) => e.theme.components.drawer.DrawerHeaderWrapper.padding};
  border-bottom: ${(e) => e.theme.components.drawer.DrawerHeaderWrapper.borderBottom};
  color: ${(e) => e.theme.components.drawer.DrawerHeaderWrapper.color};
`, Y = a.div`
  display: ${(e) => e.theme.components.drawer.DrawerFooterWrapper.display};
  max-height: ${(e) => e.theme.components.drawer.DrawerFooterWrapper.maxHeight};
  border-top: ${(e) => e.theme.components.drawer.DrawerFooterWrapper.borderTop};
  justify-content: ${(e) => e.theme.components.drawer.DrawerFooterWrapper.justifyContent};
  align-items: ${(e) => e.theme.components.drawer.DrawerFooterWrapper.alignItems};
  padding: ${(e) => e.theme.components.drawer.DrawerFooterWrapper.padding};
`, J = a.div`
  ${Q()}
  flex-grow: ${(e) => e.theme.components.drawer.DrawerChildrenWrapper.flexGrow};
  overflow-y: ${(e) => e.theme.components.drawer.DrawerChildrenWrapper.overflowY};
  padding: ${(e) => e.theme.components.drawer.DrawerChildrenWrapper.padding};
  color: ${(e) => e.theme.components.drawer.DrawerChildrenWrapper.color};
`, V = a.span`
  display: ${(e) => e.theme.components.drawer.DrawerTitleWrapper.display};
  flex-direction: ${(e) => e.theme.components.drawer.DrawerTitleWrapper.flexDirection};
  margin-top: ${(e) => e.theme.components.drawer.DrawerTitleWrapper.marginTop};
  margin-bottom: ${(e) => e.theme.components.drawer.DrawerTitleWrapper.marginBottom};
`, Z = a.span`
  display: ${(e) => e.theme.components.drawer.DrawerHeaderButtonsWrapper.display};
  flex-direction: ${(e) => e.theme.components.drawer.DrawerHeaderButtonsWrapper.flexDirection};
  align-items: ${(e) => e.theme.components.drawer.DrawerHeaderButtonsWrapper.alignItems};
`, M = a.div`
  display: ${(e) => e.theme.components.drawer.HeaderActionButtonWrapper.display};

  & .menu-alignment {
    margin-right: ${(e) => e.theme.components.drawer.HeaderActionButtonWrapper.menuAlignment.marginRight};
  }
`, ee = a(A)`
  font-family: ${(e) => e.theme.components.drawer.TitleWrapper.fontFamily};
  font-weight: ${(e) => e.theme.components.drawer.TitleWrapper.fontWeight};
  font-size: ${(e) => e.theme.components.drawer.TitleWrapper.fontSize};
  line-height: ${(e) => e.theme.components.drawer.TitleWrapper.lineHeight};
  color: ${(e) => e.theme.components.drawer.TitleWrapper.color};
`, re = a(A)`
  font-family: ${(e) => e.theme.components.drawer.SubtitleWrapper.fontFamily};
  font-weight: ${(e) => e.theme.components.drawer.SubtitleWrapper.fontWeight};
  font-size: ${(e) => e.theme.components.drawer.SubtitleWrapper.fontSize};
  line-height: ${(e) => e.theme.components.drawer.SubtitleWrapper.lineHeight};
  color: ${(e) => e.theme.components.drawer.SubtitleWrapper.color};
`, te = a.span`
  margin-right: ${(e) => e.theme.components.drawer.BadgeWrapper.marginRight};
`, _e = ({
  // drawerTitle = 'Drawer title',
  titleProp: e = { title: "Drawer title", headingLevel: "h1" },
  subTitleProp: r,
  drawerMenuItems: h,
  dropdownMenuItems: n,
  drawerBadge: p,
  onClose: g,
  accessibilityOptions: D = {}
}) => {
  const [c, d] = E(!1), { id: m } = F(z), { closeButton: u, menuIcon: $ } = D, y = C("button", {
    ariaLabel: "drawer-close-button",
    ...u
  }), i = C("button", {
    ariaLabel: "dropdown menu",
    ariaExpanded: c ? "true" : "false",
    ariaControls: `list-${m}`,
    ...$
  });
  return /* @__PURE__ */ s(X, { children: [
    /* @__PURE__ */ s(V, { children: [
      /* @__PURE__ */ t(
        ee,
        {
          as: e.headingLevel,
          id: `drawer-title-${m}`,
          children: e.title
        }
      ),
      r && /* @__PURE__ */ t(re, { as: (r == null ? void 0 : r.headingLevel) || "h2", children: r.subTitle })
    ] }),
    /* @__PURE__ */ s(Z, { children: [
      p && /* @__PURE__ */ t(te, { children: p }),
      /* @__PURE__ */ t(
        M,
        {
          onKeyDown: (o) => {
            o.key === "Escape" && c && o.stopPropagation();
          },
          children: n != null && n.items.length ? /* @__PURE__ */ s(
            b,
            {
              menuOpen: c,
              className: "menu-alignment",
              menuDirection: "down_right",
              handleMenuOpen: (o) => d(o),
              onChange: (o, l) => n.onChange && (n == null ? void 0 : n.onChange(o, l)),
              uniqueIdentifier: m,
              children: [
                /* @__PURE__ */ t(b.Control, { children: /* @__PURE__ */ t(
                  P,
                  {
                    active: c,
                    id: `control-${m}`,
                    ...i
                  }
                ) }),
                n && n.items.map((o, l) => /* @__PURE__ */ t(
                  b.Item,
                  {
                    ...o
                  },
                  l
                ))
              ]
            }
          ) : h && /* @__PURE__ */ t(
            q,
            {
              className: "menu-alignment",
              ...i,
              children: h
            }
          )
        }
      ),
      /* @__PURE__ */ t(
        U,
        {
          onClick: g,
          size: "medium",
          ...y
        }
      )
    ] })
  ] });
}, Ge = ({ children: e }) => /* @__PURE__ */ t(Y, { children: e }), Xe = ({ children: e, disclosures: r }) => /* @__PURE__ */ s(J, { children: [
  e,
  r && /* @__PURE__ */ t(
    j,
    {
      disclosureContent: r == null ? void 0 : r.disclosureContent,
      id: r == null ? void 0 : r.id,
      className: r == null ? void 0 : r.className,
      disclosureTitleColor: r == null ? void 0 : r.disclosureTitleColor,
      style: r == null ? void 0 : r.style
    }
  )
] }), ne = {
  open: { x: "-100%" },
  closed: { x: 0 }
}, oe = {
  open: { x: 0 },
  closed: { x: "-100%" }
}, Ye = ({ isOpen: e, size: r = "medium", placement: h = "right", children: n, onClose: p, accessibilityOptions: g = {}, id: D }) => {
  const c = R({ label: "Drawer" }), d = H(null), m = H(K(D ?? I)), u = {
    id: m.current
  };
  L(() => {
    var o, l;
    const i = d.current;
    if (i) {
      (o = d.current) == null || o.setAttribute("tabindex", "-1"), (l = d.current) == null || l.focus();
      const S = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', W = i.querySelectorAll(S), w = W[0], x = W[W.length - 1], v = (f) => {
        f.key === "Tab" && (f.shiftKey ? document.activeElement === w && (x.focus(), f.preventDefault()) : document.activeElement === x && (w.focus(), f.preventDefault()));
      };
      return w == null || w.focus(), i.addEventListener("keydown", v), () => {
        i.removeEventListener("keydown", v);
      };
    }
    e ? document.body.style.overflow = "hidden" : document.body.style.overflow = "";
  }, [e]);
  const $ = C("dialog", {
    ariaModal: !0,
    ariaLabelledBy: `drawer-title-${m.current}`,
    ...g
  }), y = (i) => {
    i.key === "Escape" && p && p();
  };
  return /* @__PURE__ */ t(z.Provider, { value: u, children: /* @__PURE__ */ t(N, { children: e && /* @__PURE__ */ s(B.div, { className: "overlay", children: [
    e && /* @__PURE__ */ t(
      G,
      {
        "aria-label": "drawer-overlay",
        onClick: p
      }
    ),
    /* @__PURE__ */ t(
      _,
      {
        ref: d,
        initial: "closed",
        animate: e ? "open" : "closed",
        exit: "closed",
        variants: h === "right" ? ne : oe,
        transition: { duration: 0.3 },
        size: r,
        placement: h,
        onKeyDown: y,
        id: m.current,
        ...$,
        ...c,
        children: n
      }
    )
  ] }) }) });
};
export {
  Ye as Drawer,
  Xe as DrawerContent,
  Ge as DrawerFooter,
  _e as DrawerHeader
};
